module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product6-e1a1e6ec4210c528c34cc9edf4d89810.jpg";